// Signing out and web push, moved out of App.vue so Settings (W4b) and
// the shell share one implementation.
//   signOut()        audio off, push off (while the token still authorizes
//                    it), the store's logOutUser, then home
//   toggleWebPush()  turns this browser's push on or off
//   webPushState     { supported, on, busy }, reactive
import { reactive } from "vue";
import store from "@/store";
import router from "@/router";
import * as webPush from "@/services/webPush";
import nowPlaying from "@/audio/nowPlaying.js";

export const webPushState = reactive({
  supported: webPush.isSupported(),
  on: webPush.isEnabled(),
  busy: false,
});

// After a sign-in or sign-out elsewhere, keep the toggle honest.
export function syncWebPush() {
  webPushState.on = webPush.isEnabled();
}

export async function toggleWebPush() {
  if (webPushState.busy) return;
  webPushState.busy = true;
  try {
    if (webPushState.on) {
      await webPush.disable();
    } else if (!(await webPush.enable())) {
      window.alert(
        webPush.permissionDenied()
          ? "Notifications are blocked for this site. Allow them in your browser's site settings, then try again."
          : "Couldn't turn on notifications. Try again."
      );
    }
  } catch (e) {
    console.error("Web push toggle failed", e);
    window.alert("Couldn't change notifications. Try again.");
  } finally {
    webPushState.on = webPush.isEnabled();
    webPushState.busy = false;
  }
}

// The session expired (the API's 401, a refused socket): the sign-out the
// store sees next goes to Log in with a way back (App.vue, L11).
let expired = false;
export function markSessionExpired() {
  expired = true;
}
export function takeSessionExpired() {
  const was = expired;
  expired = false;
  return was;
}

export async function signOut() {
  // Silence at once, not after the server answers (App.vue's watcher does
  // it again for every other sign-out path).
  nowPlaying.stopAll();
  // Drop this browser's push token while the JWT still authorizes it, or
  // the next account on this browser would get the old one's pushes.
  if (webPushState.on) {
    await webPush.disable().catch(() => {});
    webPushState.on = false;
  }
  // Logging out never fails locally; go home whatever the server said.
  await store.dispatch("logOutUser").catch(() => {});
  await router.replace("/").catch(() => {});
}

export default { signOut, toggleWebPush, webPushState, syncWebPush };
